module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDEydjEySDB6Ii8+PHBhdGggZD0iTTEwLjUzIDQuNjY3YzAgLjE2My0uMDYuMzIxLS4xNjguNDQzTDcuMDA1IDguODhhMS4zMzMgMS4zMzMgMCAwMS0xLjk5NC0uMDAyTDEuNjY4IDUuMTA5QS42NjcuNjY3IDAgMDEyLjE2NyA0aDcuNjk3Yy4zNjggMCAuNjY3LjI5OC42NjcuNjY3eiIgZmlsbD0iIzU3NTc1NyIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dropdown.svg
// module id = D7wK
// module chunks = 1 2 3